// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__6dKkF","title":"Info_title__3dKGS","links":"Info_links__2QlYv","link":"Info_link__Cv3cm","logo":"Info_logo__2mTW_"};